<h1 mat-dialog-title tabIndex="0" class="date-form-preview-title">
    <div>{{ 'OnSiteTrainingCreator.PreviewDateOfTraining' | translate}}: <span>{{ this.data.training.name }}</span></div>
    <i class="dolineo-icon dolineo-icon-close dolineo-icon-gray"
       matTooltip="{{'Common.Close' | translate}}"
       matTooltipPosition="below"
       matTooltipClass='below-top'
       (click)="dialogRef.close()"></i>
</h1>

<div mat-dialog-content class="date-form-preview">
    <div class="date-form-preview--section">
        <div class="date-form-preview--section--cols">
            <div class="date-form-preview--section--cols--col" style="width: 500px;">
                <div class="date-form-preview--section--title">{{ 'OnSiteTrainingCreator.PreviewDateAndPlace' | translate }}:</div>
                <div class="date-form-preview--section--rows">
                    <div class="date-form-preview--section--rows--row">
                        <i><img src="assets/icons/on-site-training-date.svg" /></i>
                        <div class="date-form-preview--section--value">{{ moment(data.date.startDate).format('DD.MM.YYYY, HH:mm') }} - {{ moment(data.date.endDate).format('HH:mm') }}</div>
                    </div>
                    <div class="date-form-preview--section--rows--row">
                        <i><img src="assets/icons/on-site-training-place.svg" /></i>
                        <div class="date-form-preview--section--value">{{ data.date.type === 'on_site' ? data.date.place :
                            (data.isPreview || data.isAssigned ? ('OnSiteTraining.OnlineTraining' | translate) : ('OnSiteTraining.LinkToTrainingVisibleToRegisteredUsers' | translate)) }}</div>
                    </div>
                </div>
            </div>
            <div class="date-form-preview--section--cols--col">
                <div class="date-form-preview--section--title">{{ 'OnSiteTrainingCreator.PreviewType' | translate }}:</div>
                <div class="date-form-preview--section--rows">
                    <div class="date-form-preview--section--rows--row">
                        <i><img src="assets/icons/on-site-training-place.svg" /></i>
                        <div class="date-form-preview--section--value" *ngIf="data.date.type === 'on_site'">{{ 'OnSiteTrainingCreator.DateTypeOnSite' | translate }}</div>
                        <div class="date-form-preview--section--value" *ngIf="data.date.type === 'webinar'">{{ 'OnSiteTrainingCreator.DateTypeWebinar' | translate }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="date-form-preview--section--cols" *ngIf="data.date.type === 'webinar' && (data.isPreview || data.isAssigned)" style="width: 100%">
            <div class="date-form-preview--section--cols--col" style="width: 100%">
                <div class="date-form-preview--section--rows" style="width: 100%">
                    <div class="date-form-preview--section--rows--row date-form-preview--buttons">
                        <button (click)="showLink()" mat-button color="primary" class="dolineo-button blue-button">{{ 'OnSiteTrainingCreator.ShowLink' | translate}}</button>
                        <div (click)="copyLink()" class="copy-link">{{ 'OnSiteTrainingCreator.CopyLink' | translate}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="date-form-preview--section">
        <div class="date-form-preview--section--cols">
            <div class="date-form-preview--section--cols--col">
                <div class="date-form-preview--section--title">{{ 'OnSiteTrainingCreator.PreviewLeader' | translate }}:</div>
                <div class="date-form-preview--section--rows">
                    <div class="date-form-preview--section--rows--row">
                        <i><img src="assets/icons/on-site-training-leader.svg" /></i>
                        <div class="date-form-preview--section--value">{{ data.date.leadersNames.join(', ') }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="date-form-preview--section">
        <div class="date-form-preview--section--cols">
            <div class="date-form-preview--section--cols--col">
                <div class="date-form-preview--section--title">{{ 'OnSiteTrainingCreator.DateDescription' | translate }}:</div>
                <div class="date-form-preview--section--rows">
                    <div class="date-form-preview--section--rows--row">
                        <i><img src="assets/icons/on-site-training-info.svg" /></i>
                        <div class="date-form-preview--section--value">{{ data.date.description }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div mat-dialog-actions class="dialog-footer">
    <button (click)="dialogRef.close()" mat-button color="primary"
            class="dolineo-button blue-button">{{ 'Common.Close' | translate}}</button>
</div>